import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { environment } from '@env/environment';
import { UsersService } from '@services/users.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private usersService: UsersService, private storageService: StorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to api url
    const user = this.usersService.userValue;
    const sessionKey = (this.storageService.get('SessionKey') || '');
    const isLoggedIn = user && sessionKey;
    const isApiUrl = request.url.startsWith(environment.apiUrl);

    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${sessionKey}`
        }
      });
    }

    // headerdan token bilgisini alıp localstorage'e set ediyoruz.
    return next.handle(request)
      .pipe(tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const token = event.headers.get('Authorization');
          if (token) {
            this.storageService.set('SessionKey', token.split('Bearer ')[1]);
          }
        }
      }));
  }
}
